import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Helmet } from "react-helmet";
import axios from 'axios';


const Login = (props) => {
    const { t } = useTranslation();

    const handleBack = () => {
        window.history.back();
    };

    var preidioma = ""
    if (props.lang != 'es') preidioma = props.lang + "/";

    const [mostrarContrasenya, setMostrarContrasenya] = useState(false);

    const handleToggleContrasenya = () => {
        setMostrarContrasenya(!mostrarContrasenya);
    };

    const tipoInput = mostrarContrasenya ? 'text' : 'password';

    const [tieneContenidoEmail, setTieneContenidoEmail] = useState(false);
    const [tieneContenidoPassword, setTieneContenidoPassword] = useState(false);

    const handleInputChangeEmail = (e) => {
        setTieneContenidoEmail(e.target.value.trim().length > 0);
    };

    const handleInputChangePassword = (e) => {
        setTieneContenidoPassword(e.target.value.trim().length > 0);
    };

    {/* *************** */ }

    const [dataRes, setDataRes] = useState("<p></p>");

    const handleSubmit = (e) => {

        e.preventDefault();
        let token = document.getElementById('meta_token').getAttribute('content');

        const result = axios.post('/dologin', {
            lang: e.target.lang.value,
            user: e.target.username.value,
            password: e.target.password.value
        }, {
            headers: {
                'content-type': 'application/json',
                'X-CSRF-TOKEN': token
            }
        })
            .then((response) => {
                const solucion = response.data;
                if (solucion.type == "success") {
                    setDataRes("<p style='color:green'>" + solucion.message + "</p>");

                    let date = new Date();
                    date.setTime(date.getTime() + (60 * 60 * 24000)); //24 horas
                    let arraystring = JSON.stringify(response.data.datos);

                    const hostname = window.location.hostname;

                    document.cookie = `datos = ${encodeURIComponent(arraystring)}; expires = ${date.toGMTString()}; path=/; domain=${hostname}`;
                    window.location.href = "/" + preidioma;
                }
                else {
                    setDataRes("<p  style='color:red'>" + solucion.message + "</p>");
                }

            });
    }

    {/* *************** */ }

    return (
        <>
            <Helmet>
                <link rel="stylesheet" href={"/css/web/valesuites/styles_login_vale.css"} media="screen" />
            </Helmet>

            <div className="container">
                <div className="login-widget">
                    <main className="_widget login">
                        <section className="c57665789 _prompt-box-outer c323c2011">
                            <div className="c65ea1c48 c1e484642">
                                <div className="c7d1b954c">
                                    <header className="cd35e613e cbb75511c">
                                        <div title="H10 Hotels" id="custom-prompt-logo" style={{ width: "auto", height: "60px", position: "static", margin: "auto", padding: "0", backgroundColor: "transparent", backgroundPosition: "center", backgroundSize: "contain", backgroundRepeat: "no-repeat" }}></div>
                                        <div style={{ textAlign: "left", margin: "0px 0px 10px auto", width: "100%", textTransform: "uppercase" }}>
                                            <span>
                                                <a href="#" onClick={handleBack}>←{t("Volver")}</a>
                                            </span>
                                        </div>
                                        {
                                            props.websgrupo.logo !== "" ?
                                                <img className="cc90051d2 c5ff2b4e4" id="prompt-logo-center" alt="Valesuites" src={props.ruta + "/web/logo/web/" + props.websgrupo.logo} />
                                                :
                                                props.websgrupo.logo_fiscal != "" ?
                                                    <img className="cc90051d2 c5ff2b4e4" id="prompt-logo-center" alt="Valesuites" src={props.ruta + "/web/logo/" + props.websgrupo.logo_fiscal} />
                                                    :
                                                    <img className="cc90051d2 c5ff2b4e4" id="prompt-logo-center" alt="Valesuites" src="https://www.bedloop.com/imatges/logo.webp" />
                                        }
                                        <h1 className="c4a02d3c0 c76a2dbda">{t("INICIAR SESIÓN")}</h1>
                                        <div className="c25421b0e cf2b2ca7d">
                                            <p className="c904131e5 c244602df"></p>
                                        </div>
                                    </header>
                                    <div className="c935aed04 c09f63c78">
                                        <form method="POST" className="ccac46ac0 c8328957f" data-form-primary="true" data-disable-html-validations="true" noValidate="" onSubmit={handleSubmit}>
                                            <input type="hidden" name="lang" value={props.lang.toString().toUpperCase()} />

                                            <div id="ulp-container-form-content-start"></div>
                                            <div className="c7d0b3e3c cf227995b">
                                                <div className="c910d7a1a">
                                                    <div className="input-wrapper _input-wrapper">
                                                        <div className={`c17fa8fd8 cf95f0a1e text c3868a0ee ulp - field c14e5721b ${tieneContenidoEmail ? 'c232b3df2' : ''} `} data-action-text="" data-alternate-action-text="">
                                                            <label id="username-label" className="cd62805dc ca3268a44 c3e69e1c8" htmlFor="username"> {t("E-mail")} <span className="required" aria-hidden="true">*</span>
                                                            </label>
                                                            <input className="input cde341dc3 cf7ebb50e" inputMode="text" name="username" id="username" type="text" aria-labelledby="username-label" aria-required="true" defaultValue="" required="" autoComplete="username" autoCapitalize="none" spellCheck="false" onChange={handleInputChangeEmail} />
                                                        </div>
                                                        <div id="error-cs-username-required" className="ulp-error-info aria-error-check" data-ulp-validation-function="ulpRequiredFunction" data-ulp-validation-event-listeners="blur,change,input,focus" data-ulp-validation-target="username" aria-live="polite" aria-atomic="true"> {t("Se requiere una dirección de correo electrónico o un nombre de usuario")} </div>
                                                        <div id="error-cs-pattern-mismatch" className="ulp-error-info aria-error-check" data-ulp-validation-function="ulpPatternCheckFunction" data-ulp-validation-event-listeners="blur,change,input,focus" data-ulp-validation-target="username" aria-live="polite" aria-atomic="true">{t("Introduzca una dirección de correo electrónico o un nombre de usuario válido")}</div>
                                                    </div>
                                                    <div className="input-wrapper _input-wrapper">
                                                        <div className={`c17fa8fd8 cf95f0a1e password c44cdd79f ulp - field c14e5721b ${tieneContenidoPassword ? 'c232b3df2' : ''} `} data-action-text="" data-alternate-action-text="">
                                                            <label id="password-label" className="cd62805dc ca3268a44 c188136b4" htmlFor="password"> {t("Contraseña")} <span className="required" aria-hidden="true">*</span>
                                                            </label>
                                                            <input className="input cde341dc3 c0c0280cd" name="password" id="password" type={tipoInput} aria-labelledby="password-label" aria-required="true" required="" autoComplete="current-password" autoCapitalize="none" spellCheck="false" onChange={handleInputChangePassword} />
                                                            <button type="button" role="switch" aria-checked={mostrarContrasenya} aria-label={mostrarContrasenya ? "Ocultar contraseña" : "Mostrar contraseña"} className="cd1a990da ulp-button-icon js-required c08def9fe _button-icon" data-action="toggle" onClick={handleToggleContrasenya}>
                                                                <span aria-hidden="true" className={`password - icon - tooltip show - password - tooltip ${!mostrarContrasenya ? '' : 'hide'} `}>{t("Mostrar contraseña")}</span>
                                                                <span aria-hidden="true" className={`password - icon - tooltip hide - password - tooltip ${mostrarContrasenya ? '' : 'hide'} `}>{t("Ocultar contraseña")}</span>
                                                                <span className="ccad6d0ca password js-required" aria-hidden="true"></span>
                                                            </button>
                                                        </div>
                                                        <div id="error-cs-password-required" className="ulp-error-info aria-error-check" data-ulp-validation-function="ulpRequiredFunction" data-ulp-validation-event-listeners="blur,change,input,focus" data-ulp-validation-target="password" aria-live="polite" aria-atomic="true">{t("La contraseña es requerida")} </div>
                                                        <div id="error-cs-password-password-too-weak" className="ulp-error-info aria-error-check" data-ulp-validation-function="ulpPasswordPolicyFunction" data-ulp-validation-event-listeners="blur,change,input,focus" data-ulp-validation-target="password" aria-live="polite" aria-atomic="true">{t("La contraseña es muy débil")}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="c0efdd1fd c352ea2bc">
                                                <a className="c732759d9 c2d3f1f5e ca223ca71" href="/u/login/password-reset-start/Username-Password-Authentication?state=hKFo2SBDTmU1X3FNS3lJLXJwU1NaSVpCYlB1X0p1ZWtLdHNqdqFur3VuaXZlcnNhbC1sb2dpbqN0aWTZIEkzUk9TM0JMMENET0R3NzJKSHZpX0VYVzA4TzJhbHR1o2NpZNkgMVZYcWh4QmNKQ0t4TUtoS3ROQUllelZvMTJNYzdZRnM&amp;ui_locales=es">{t("He olvidado mi contraseña")}</a>
                                            </p>
                                            <div id="ulp-container-form-content-end">
                                                <div className="ulp-field">
                                                    <input type="checkbox" name="ulp-remember-me" id="remember-me" />
                                                    <label htmlFor="remember-me" id="remember-me-label">{t("Recuérdame")}</label>
                                                </div>
                                            </div>
                                            <div className="ca91a1d88">
                                                <button type="submit" name="action" defaultValue="default" className="cd1a990da cba6662c1 c08def9fe c51df775b ca670e4d9" data-action-button-primary="true">{t("ACCEDER")}</button>
                                            </div>
                                        </form>
                                        <div dangerouslySetInnerHTML={{ __html: dataRes }}></div>
                                        <div id="ulp-container-form-footer-start"></div>
                                        <div id="ulp-container-form-footer-end"></div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div>
                <div className="image-side" style={{ flex: "1", backgroundImage: "url('/images/web/valesuites/pareja_sofa_inicio_sesion.png')", backgroundSize: "cover", backgroundPosition: "center" }}></div>
            </div>
        </>
    );
}
export default Login;
